import { useRecoilState } from 'recoil';
import { bottomBarOpenState } from 'store';
import BottomBar from './BottomBar';

const BottomBarWithRecoil = (props: any) => {
  const [bbIsOpen, setBbIsOpen] = useRecoilState(bottomBarOpenState);

  return <BottomBar {...props} reelOpen={bbIsOpen} setReelOpen={setBbIsOpen} />;
};

export default BottomBarWithRecoil;
